import type { AxiosError } from "axios"

import axiosInstance, { endpoints } from "../utils/axios"

import type { ApiResponse } from "../types/apiResponse"

export const enqueueLeadProfilePdf = async (leadId: string): Promise<ApiResponse<void>> => {
    try {
        await axiosInstance.post(endpoints.pdf.enqueue, { leadId })
        return { status: "success" }
    } catch (error) {
        console.log(error)
        return {
            status: "error",
            errorMessage: (error as AxiosError).response?.status,
        }
    }
}

export const fetchLeadProfilePdfUrl = async (leadId: string): Promise<ApiResponse<string | undefined>> => {
    try {
        const response = await axiosInstance.get(`${endpoints.leads.details}${leadId}`)
        return {
            status: "success",
            data: response?.data?.data?.profilePdfSignedUrl,
        }
    } catch (error) {
        console.log(error)
        return {
            status: "error",
            errorMessage: (error as AxiosError).response?.status,
        }
    }
}

export const refreshLeadProfilePdfUrl = async (leadId: string): Promise<ApiResponse<string>> => {
    try {
        const response = await axiosInstance.get(`${endpoints.pdf.signedUrl}?leadId=${leadId}`)
        return {
            status: "success",
            data: response?.data?.data?.signedUrl,
        }
    } catch (error) {
        console.log(error)
        return {
            status: "error",
            errorMessage: (error as AxiosError).response?.status,
        }
    }
}
